module.exports = __webpack_public_path__ + "img/contents_market_main_02.7b429d6.png";